import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2"; // Changed from HorizontalBar to Bar
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "../../utils/common";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

function BarChart({ data }) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const predefinedYears = [
    2018, 2013, 2009, 2004, 1999, 1994, 1989, 1984, 1979,
  ];

  // Construct the labels and dataObj arrays based on the predefined years
  const labels = [];
  const dataObj = [];
  const backgroundColors = [];
  const yAxisLabelColors = [];

  predefinedYears.forEach((year) => {
    labels.push(year);

    const yearData = data.find((item) => item.year === year);

    if (yearData) {
      dataObj.push(yearData.votes);
      backgroundColors.push("#14557A");
      yAxisLabelColors.push("black");
    } else {
      dataObj.push("");
      yAxisLabelColors.push("#D9D9D9");
    }
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: "votes",
        data: dataObj,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    indexAxis: "y", // Set to 'y' for horizontal bar chart
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        right: 50,
        left: 20,
      },
    },
    scales: {
      y: {
        grid: {
          drawOnChartArea: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: (context) => {
            const year = context.tick.label;
            const yearData = data.find((item) => item.year === year);
            return yearData ? "black" : "#D9D9D9";
          },
        },
      },
      x: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.x !== null) {
              label += formatNumber(context.parsed.x.toString(), language);
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "right",
        formatter: function (value, context) {
          return formatNumber(value.toString(), language);
        },
        color: "black",
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default BarChart;
